export default __webpack_public_path__ + "static/media/cesardiniz.a358f6a1.png";